import React from 'react'
import { Accordion } from '@ally/metronome-ui'
import { TransactionDetails, CheckDetails } from '../../../../../types'
import { CheckImageDrawerContent } from './CheckImageDrawerContent'

interface CheckImagesProps {
  transactionDetail: TransactionDetails
  printCheckCallback: (checkDetails: CheckDetails) => void
}

export const CheckImages: React.FC<CheckImagesProps> = ({
  transactionDetail,
  printCheckCallback,
}) => {
  return (
    <>
      <Accordion
        disableContainer
        items={[
          {
            heading: 'View check images',
            panel: (
              <CheckImageDrawerContent
                printCheckCallback={printCheckCallback}
                transactionDetail={transactionDetail}
              />
            ),
          },
        ]}
      />
    </>
  )
}
